import { api } from '@setplex/tria-api'
import { attach, createEvent } from 'effector'
import { produce } from 'immer'
import { runtime } from '~/app/environment'

type SignInParams = {
  username?: string
  password?: string
  rememberMe?: boolean
  model?: string
  foreignPlatformAccessToken?: string
}

export const signIn = createEvent<SignInParams>()

export const signOut = createEvent()

export const signInFx = attach({
  effect: api.session.signInFx,
  mapParams: produce<SignInParams>((params) => {
    params.model = `${runtime.browser.name} ${runtime.browser.version}`
  }),
})

export const signOutFx = attach({ effect: api.session.signOutFx })
